var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M13.7 6.3c.2-.2.3-.5.3-.8 0-.3 0-.6-.3-1-.5-.3-1.2-.3-1.7 0l-4 4-4-4-.8-.2c-.4 0-.6 0-1 .3l-.2 1c0 .2 0 .5.3.7l5 5 .7.2c.3 0 .6 0 .8-.3l5-5z"}));
}

DownArrow.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
